<template>
  <div class="teaser">
    <div class="image">
      <img :src="teaser.imagePath" alt="" />
    </div>
    <div class="content">
      <div class="text">{{ teaser.text }}</div>
      <sanitas-button secondary @sanitas_button_tap="buttonClicked">
        {{ teaser.buttonText }}
      </sanitas-button>
      <ul class="links">
        <li v-for="(link, i) in teaser.links" :key="i">
          <a
            class="sanitas-core-link"
            :href="link.href"
            :target="getTarget(link)"
          >
            <dotcom-icon name="arrow-right-long" art="regular" />
            {{ link.label }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WizardTeaser',
  components: {
    DotcomIcon: () => {
      return import(
        /* webpackChunkName: "dotcom-icon" */
        '@/modules/icon/Icon'
      )
    },
    SanitasButton: () => {
      return import(
        /* webpackChunkName: "sanitas-components" */
        '@/components/sanitas-components/SanitasButton'
      )
    },
  },
  props: {
    teaser: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    buttonClicked() {
      const { teaser } = this
      if (!teaser || !teaser.buttonLink) {
        return
      }

      if (teaser.buttonNewTab) {
        window.open(teaser.buttonLink, '_blank')
      } else {
        document.location.replace(teaser.buttonLink)
      }
    },
    getTarget(item) {
      return item.newTab === true ? '_blank' : '_self'
    },
  },
}
</script>

<style scoped>
.image {
  width: 65%;
  margin: auto;
  border: 1px solid var(--c-secondary-neutral-3);
  border-radius: 50%;
  padding: 5px;

  img {
    max-width: 100%;
    border-radius: 50%;
    box-sizing: border-box;
    position: relative;
    top: 2px;
  }
}

.text {
  font-weight: 300;
  font-style: normal;
  font-size: 20px;
  line-height: 1.25;
  color: var(--c-primary-neutral-1);
  margin: 30px 0 20px 0;
}

ul.links {
  margin: 30px 0 0;
  padding: 0 !important;

  li {
    padding: 0;
    margin: 0;
    list-style-type: none;

    & >>> .dotcom-icon {
      margin-right: var(--spacing-1);
    }
  }
}

@media (max-width: 1023px) and (--sm) {
  .teaser {
    display: flex;
  }

  .image {
    width: 50%;
    margin-right: 30px;
  }
}
</style>
